export default function DashboardBlockShell({
  id,
  title,
  description,
  badge = "Pilot actiu",
  loading = false,
  loadingText = "Carregant…",
  error = null,
  children,
}) {
  return (
    <section
      id={id}
      className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm"
    >
      <div className="flex items-start justify-between gap-3 mb-4">
        <div>
          <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
          <p className="text-sm text-slate-600 mt-1">{description}</p>
        </div>

        <div className="text-xs rounded-full bg-emerald-100 text-emerald-800 px-3 py-1 whitespace-nowrap">
          {badge}
        </div>
      </div>

      {loading ? (
        <div className="rounded-xl border border-slate-200 bg-slate-50 px-4 py-4 text-sm text-slate-600">
          {loadingText}
        </div>
      ) : error ? (
        <div className="rounded-xl border border-red-200 bg-red-50 px-4 py-4 text-sm text-red-700">
          {error}
        </div>
      ) : (
        children
      )}
    </section>
  );
}
